// helpers
import VScope from '../components/helpers/v-scope.vue';
import VSource from '../components/helpers/v-source.vue';
import VModelSource from '../components/helpers/v-model-source.vue';
import VLoader from '../components/helpers/v-loader.vue';
import VSvgIcon from '../components/helpers/v-svg-icon.vue';
import VImage from '../components/helpers/v-image.vue';
import VVideo from '../components/helpers/v-video.vue';
import VLazyComponent from '../components/helpers/v-lazy-component.vue';

// plugins
import VSwiperSlider from '../components/v-swiper-slider.vue'; // https://swiperjs.com/vue/

// forms
import VForm from '../components/v-form.vue';
import VField from '../components/v-field.vue';
import VFieldText from '../components/v-field-text.vue';
import VFieldSelect from '../components/v-field-select.vue';
import VFieldMultiSelect from '../components/v-field-multi-select.vue';
import VFieldCheckbox from '../components/v-field-checkbox.vue';
import VFieldCheckList from '../components/v-field-check-list.vue';
import VFieldTumbler from '../components/v-field-tumbler.vue';
import VFieldTumblerList from '../components/v-field-tumbler-list.vue';
import VFieldCount from '../components/v-field-count.vue';
import VFieldRange from '../components/v-field-range.vue';
import VFieldRangeSlider from '../components/v-field-range-slider.vue';
import VFieldFile from '../components/v-field-file.vue';
import VFieldViewPicker from '../components/v-field-view-picker.vue';
import VFieldTel from '../components/v-field-tel.vue';
import VFieldCode from '../components/v-field-code.vue';
import VFieldCurrency from '../components/v-field-currency.vue';
import VFieldAvatar from '../components/v-field-avatar.vue';
import VFieldToggler from '../components/v-field-toggler.vue';
import VRating from '../components/v-rating.vue';
import VDatepicker from '../components/v-datepicker.vue';

// blocks
import VAppWidget from '../components/v-app-widget.vue';
import VPageSection from '../components/v-page-section.vue';
import VPageSectionHeader from '../components/v-page-section-header.vue';
import VHeroBlock from '../components/v-hero-block.vue';
import VHeroSlider from '../components/v-hero-slider.vue';
import VPrice from '../components/v-price.vue';
import VStatus from '../components/v-status.vue';
import VCatalog from '../components/v-catalog.vue';
import VCatalogCompare from '../components/v-catalog-compare.vue';
import VCollapse from '../components/v-collapse.vue';
import VBasket from '../components/v-basket.vue';
import VFilter from '../components/v-filter.vue';
import VFilterActiveItems from '../components/v-filter-active-items.vue';
import VPageNav from '../components/v-page-nav.vue';
import VAvailability from '../components/v-availability.vue';
import VTopNav from '../components/v-top-nav.vue';
import VMainNav from '../components/v-main-nav.vue';
import VMobileNav from '../components/v-mobile-nav.vue';
import VPageHeader from '../components/v-page-header.vue';
import VBasketSmall from '../components/v-basket-small.vue';
import VBasketAction from '../components/v-basket-action.vue';
import VCompareAction from '../components/v-compare-action.vue';
import VFavoriteSmall from '../components/v-favorite-small.vue';
import VFavoriteAction from '../components/v-favorite-action.vue';
import VCompareSmall from '../components/v-compare-small.vue';
import VProductGrid from '../components/v-product-grid.vue';
import VProductList from '../components/v-product-list.vue';
import VProductLine from '../components/v-product-line.vue';
import VProductSlider from '../components/v-product-slider.vue';
import VImageSlider from '../components/v-image-slider.vue';
import VProduct from '../components/v-product.vue';
import VProductImage from '../components/v-product-image.vue';
import VArticleGrid from '../components/v-article-grid.vue';
import VArticlePoster from '../components/v-article-poster.vue';
import VCatalogItem from '../components/v-catalog-item.vue';
import VSearchSmall from '../components/v-search-small.vue';
import VModal from '../components/v-modal.vue';
import VModalWindow from '../components/v-modal-window.vue';
import VGallery from '../components/v-gallery.vue';
import VMap from '../components/v-map.vue';
import VLocationPicker from '../components/v-location-picker.vue';
import VContactsList from '../components/v-contacts-list.vue';
import VNotifications from '../components/v-notifications.vue';
import VPageFooter from '../components/v-page-footer.vue';
import VBreadcrumbs from '../components/v-breadcrumbs.vue';
import VTabs from '../components/v-tabs.vue';
import VNewSlider from '../components/v-new-slider.vue';
import VConverter from '../components/v-converter.vue';
import VThemeToggler from '../components/v-theme-toggler.vue';
import VAccordion from '../components/v-accordion.vue';
import VDumbBanner from '../components/v-dumb-banner.vue';
import VHalfBanner from '../components/v-half-banner.vue';
import VBtnScrollTop from '../components/v-btn-scroll-top.vue';
import VMainSectionHeader from "../components/v-main-section-header.vue";
import VCollectionCard from '../components/v-collection-card.vue';
import VCollectionLgCard from "../components/v-collection-lg-card.vue";
import VMainPageSection from "../components/v-main-page-section.vue";
import VSectionSlider from "../components/v-section-slider.vue";
import VCatalogCard from "../components/v-catalog-card.vue";
import VModalMenu from "../components/v-modal-menu.vue";
import VPropertyCard from "../components/v-property-card.vue";
import VSectionBottomSlider from "../components/v-section-bottom-slider.vue";
import VSectionBottom from "../components/v-section-bottom.vue";
import VCollectionMdCard from "../components/v-collection-md-card.vue";
import VProductCard from "../components/v-product-card.vue";
import VSectionAchievements from "../components/v-section-achievements.vue";
import VSectionTopCard from "../components/v-section-top-card.vue";
import VSectionTop from "../components/v-section-top.vue";
import VManagement from "../components/v-management.vue";
import VFeedbackForm from "../components/v-feedback-form.vue";
import VFooterIcons from "../components/v-footer-icons.vue";
import VSubfooterIcons from "../components/v-subfooter-icons.vue";
import VMainHeader from "../components/v-main-header.vue";
import VMapAsideCard from "../components/v-map-aside-card.vue";
import VMapPage from "../components/v-map-page.vue";
import VDetailAsideCard from "../components/v-detail-aside-card.vue";
import VFeaturesCard from "../components/v-features-card.vue";
import VFeaturesSlider from "../components/v-features-slider.vue";
import VDetailSlider from "../components/v-detail-slider.vue";
import VDetailPage from "../components/v-detail-page.vue";
import VModalRoom3d from "../components/v-modal-room-3d.vue";
import VNewsPage from "../components/v-news-page.vue";
import VAwardsPage from "../components/v-awards-page.vue";
import VNewsCard from "../components/v-news-card.vue";
import VObjectsPage from "../components/v-objects-page.vue";
import VCalculator from "../components/v-calculator.vue";
import VNotFoundPage from "../components/v-not-found-page.vue";
import VDetailNews from "../components/v-detail-news.vue";
import VCollections from "../components/v-collections.vue";
import VVacanciesPage from "../components/v-vacancies-page.vue";
import VVacancyCard from "../components/v-vacancy-card.vue";
import VHelp from "../components/v-help.vue";
import VHelpCard from "../components/v-help-card.vue";
import VContactsPage from "../components/v-contacts-page.vue";
import VCalculatorPage from "../components/v-calculator-page.vue";
import VModalCookie from "../components/v-modal-cookie.vue";
import VAsideCollections from "../components/v-aside-collections.vue";
import VSearchResult from "../components/v-search-result.vue";
import VFlexCollection from "../components/v-flex-collection.vue";
import VMapGoogle from "../components/v-map-google.vue";
import VPageText from "../components/v-page-text.vue";
import VCollectionDetail from "../components/v-collection-detail.vue";
import VGridImage from "../components/v-grid-image.vue";
import VOffersProduct from "../components/v-offers-product.vue";
import VDocuments from "../components/v-documents.vue";
import VCollectionSlider from "../components/v-collection-slider.vue";
import VTileSlider from "../components/v-tile-slider.vue";
import VFilesPage from "../components/v-files-page.vue";
import VImageSliderGallery from "../components/v-image-slider-gallery.vue";
import VManagementTiming from "../components/v-management-timing.vue";
import VManagementTimingCall from "../components/v-management-timing-call.vue";
import VOrganizationDetails from "../components/v-organization-details.vue";
import VFieldSelectSearch from "../components/v-field-select-search.vue";

export default {
	// helpers
	'v-scope': VScope,
	'v-source': VSource,
	'v-model-source': VModelSource,
	'v-loader': VLoader,
	'v-svg-icon': VSvgIcon,
	'v-image': VImage,
	'v-video': VVideo,
	'v-lazy-component': VLazyComponent,

	// plugins
	'v-swiper-slider': VSwiperSlider,

	// forms
	'v-form': VForm,
	'v-field': VField,
	'v-field-text': VFieldText,
	'v-field-select': VFieldSelect,
	'v-field-multi-select': VFieldMultiSelect,
	'v-field-checkbox': VFieldCheckbox,
	'v-field-check-list': VFieldCheckList,
	'v-field-tumbler': VFieldTumbler,
	'v-field-tumbler-list': VFieldTumblerList,
	'v-field-count': VFieldCount,
	'v-field-range': VFieldRange,
	'v-field-range-slider': VFieldRangeSlider,
	'v-field-file': VFieldFile,
	'v-field-view-picker': VFieldViewPicker,
	'v-field-tel': VFieldTel,
	'v-field-code': VFieldCode,
	'v-field-currency': VFieldCurrency,
	'v-field-avatar': VFieldAvatar,
	'v-field-toggler': VFieldToggler,
	'v-rating': VRating,
	'v-datepicker': VDatepicker,

	// blocks
	'v-app-widget': VAppWidget,
	'v-page-section': VPageSection,
	'v-page-section-header': VPageSectionHeader,
	'v-hero-block': VHeroBlock,
	'v-hero-slider': VHeroSlider,
	'v-price': VPrice,
	'v-status': VStatus,
	'v-catalog': VCatalog,
	'v-catalog-compare': VCatalogCompare,
	'v-collapse': VCollapse,
	'v-basket': VBasket,
	'v-filter': VFilter,
	'v-filter-active-items': VFilterActiveItems,
	'v-page-nav': VPageNav,
	'v-availability': VAvailability,
	'v-top-nav': VTopNav,
	'v-main-nav': VMainNav,
	'v-mobile-nav': VMobileNav,
	'v-page-header': VPageHeader,
	'v-basket-small': VBasketSmall,
	'v-basket-action': VBasketAction,
	'v-compare-action': VCompareAction,
	'v-favorite-small': VFavoriteSmall,
	'v-favorite-action': VFavoriteAction,
	'v-compare-small': VCompareSmall,
	'v-product-grid': VProductGrid,
	'v-product-list': VProductList,
	'v-product-line': VProductLine,
	'v-product-slider': VProductSlider,
	'v-image-slider': VImageSlider,
	'v-product': VProduct,
	'v-product-image': VProductImage,
	'v-article-grid': VArticleGrid,
	'v-article-poster': VArticlePoster,
	'v-catalog-item': VCatalogItem,
	'v-search-small': VSearchSmall,
	'v-modal': VModal,
	'v-modal-window': VModalWindow,
	'v-gallery': VGallery,
	'v-map': VMap,
	'v-location-picker': VLocationPicker,
	'v-contacts-list': VContactsList,
	'v-notifications': VNotifications,
	'v-page-footer': VPageFooter,
	'v-breadcrumbs': VBreadcrumbs,
	'v-tabs': VTabs,
	'v-new-slider': VNewSlider,
	'v-converter': VConverter,
	'v-theme-toggler': VThemeToggler,
	'v-accordion': VAccordion,
	'v-dumb-banner': VDumbBanner,
	'v-half-banner': VHalfBanner,
	'v-btn-scroll-top': VBtnScrollTop,
	'v-main-section-header': VMainSectionHeader,
	'v-collection-card': VCollectionCard,
	'v-collection-lg-card': VCollectionLgCard,
	'v-main-page-section': VMainPageSection,
	'v-section-slider': VSectionSlider,
	'v-catalog-card': VCatalogCard,
	'v-modal-menu': VModalMenu,
	'v-property-card': VPropertyCard,
	'v-section-bottom-slider': VSectionBottomSlider,
	'v-section-bottom': VSectionBottom,
	'v-collection-md-card': VCollectionMdCard,
	'v-product-card': VProductCard,
	'v-section-achievements': VSectionAchievements,
	'v-section-top-card': VSectionTopCard,
	'v-section-top': VSectionTop,
	'v-management': VManagement,
	'v-management-timing': VManagementTiming,
	'v-feedback-form': VFeedbackForm,
	'v-footer-icons': VFooterIcons,
	'v-subfooter-icons': VSubfooterIcons,
	'v-main-header': VMainHeader,
	'v-map-aside-card': VMapAsideCard,
	'v-map-page': VMapPage,
	'v-detail-aside-card': VDetailAsideCard,
	'v-features-card': VFeaturesCard,
	'v-features-slider': VFeaturesSlider,
	'v-detail-slider': VDetailSlider,
	'v-detail-page': VDetailPage,
	'v-modal-room-3d': VModalRoom3d,
	'v-news-page': VNewsPage,
	'v-awards-page': VAwardsPage,
	'v-news-card': VNewsCard,
	'v-objects-page': VObjectsPage,
	'v-calculator': VCalculator,
	'v-not-found-page': VNotFoundPage,
	'v-detail-news': VDetailNews,
	'v-collections': VCollections,
	'v-vacancies-page': VVacanciesPage,
	'v-vacancy-card': VVacancyCard,
	'v-help': VHelp,
	'v-help-card': VHelpCard,
	'v-aside-collections': VAsideCollections,
	'v-search-result': VSearchResult,
	'v-flex-collection': VFlexCollection,
	'v-contacts-page': VContactsPage,
	'v-calculator-page': VCalculatorPage,
	'v-modal-cookie': VModalCookie,
	'v-map-google': VMapGoogle,
	'v-page-text': VPageText,
	'v-collection-detail': VCollectionDetail,
	'v-grid-image': VGridImage,
	'v-offers-product': VOffersProduct,
	'v-documents': VDocuments,
	'v-collection-slider': VCollectionSlider,
	'v-tile-slider': VTileSlider,
	'v-files-page': VFilesPage,
	'v-image-slider-gallery': VImageSliderGallery,
	'v-management-timing-call': VManagementTimingCall,
	'v-organization-details': VOrganizationDetails,
	'v-field-select-search': VFieldSelectSearch,
};